(function(){
  const RATE = 1.95583;
  function bgnFromEurText(raw){
    if(!raw) return null;
    let s = String(raw).replace(/\s/g,'');
    let m = s.match(/(\d+(?:[.,]\d{1,2})?)\s*(?:€|EUR)/i);
    if(!m) return null;
    let n = parseFloat(m[1].replace(',', '.'));
    if(!isFinite(n)) return null;
    return (n * RATE).toLocaleString('bg-BG',{minimumFractionDigits:2,maximumFractionDigits:2}) + ' лв';
  }
  function enhanceTextNode(node){
    const text = node.nodeValue;
    if(!text || text.indexOf('лв') !== -1 || text.indexOf('BGN') !== -1) return;
    const re = /(\d+(?:[\s.]\d{3})*(?:[,.]\d{2})?\s*(?:€|EUR))/gi;
    if(!re.test(text)) return;
    re.lastIndex = 0;
    const frag = document.createDocumentFragment();
    let last = 0, match;
    while((match = re.exec(text))){
      frag.appendChild(document.createTextNode(text.slice(last, match.index)));
      const eur = match[1];
      const bgn = bgnFromEurText(eur);
      if(bgn){
        const span = document.createElement('span');
        span.className = 'kz-dual-price';
        span.setAttribute('data-kz-dual-js','');
        span.innerHTML = '<span class="kz-price-eur"></span><span class="kz-price-sep">/</span><span class="kz-price-bgn"></span>';
        span.children[0].textContent = eur.trim();
        span.children[2].textContent = bgn;
        frag.appendChild(span);
      } else {
        frag.appendChild(document.createTextNode(eur));
      }
      last = re.lastIndex;
    }
    frag.appendChild(document.createTextNode(text.slice(last)));
    node.parentNode.replaceChild(frag, node);
  }
  function run(root){
    root = root || document.body;
    if(!root) return;
    const skip = new Set(['SCRIPT','STYLE','NOSCRIPT','TEXTAREA','INPUT','SELECT','OPTION']);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node){
        const p = node.parentElement;
        if(!p || skip.has(p.tagName) || p.closest('[data-kz-dual-price],[data-kz-dual-js]')) return NodeFilter.FILTER_REJECT;
        if(!/[€]|EUR/i.test(node.nodeValue) || /лв|BGN/i.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    const nodes=[]; let n;
    while((n=walker.nextNode())) nodes.push(n);
    nodes.forEach(enhanceTextNode);
  }
  document.addEventListener('DOMContentLoaded', function(){ run(document.body); });
  document.addEventListener('cart:refresh', function(){ setTimeout(function(){ run(document.body); }, 60); });
  document.addEventListener('shopify:section:load', function(e){ run(e.target); });
})();
